import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import VueAnalytics from 'vue-analytics'
import VueMeta from 'vue-meta'

// Google Analytics
if (process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_ID) {
  Vue.use(VueAnalytics, {
    id: process.env.VUE_APP_GOOGLE_ANALYTICS_TRACKING_ID,
    router
  })
}

// Meta
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
